import { render, staticRenderFns } from "./ShopId.vue?vue&type=template&id=0fa506ce&"
import script from "./ShopId.vue?vue&type=script&lang=js&"
export * from "./ShopId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports